import { render, staticRenderFns } from "./persetujuan.vue?vue&type=template&id=86da3dd2"
import script from "./persetujuan.vue?vue&type=script&lang=js"
export * from "./persetujuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports